module.exports = __webpack_public_path__ + "img/feizhu.cc2b1ab7.png";